module.exports = __webpack_public_path__ + "static/how-it-works-4ea8385144165fc494c3c44cd7fb88e1.webm";